import React, { useEffect, useRef, useState } from "react";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyles";
import logo from "../../logo.png";
import { SiteName } from "../../global/SiteName";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FiGrid, FiTruck, FiUser, FiUsers } from "react-icons/fi";
import api from "../../global/api";
import { logout } from "../../app/features/userSlice";
import toast from "react-hot-toast";
import DarkModeToggle from "../darkMode/DarkModeToggle";
import MenuToggleButton from "./components/MenuToggleButton";

const menu = [
  {
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: <FiGrid />,
  },
  {
    name: "Manage shipments",
    path: "/admin/dashboard/manage-shipping",
    icon: <FiTruck />,
  },
  {
    name: "Manage users",
    path: "/admin/dashboard/manage-users",
    icon: <FiUsers />,
  },
  {
    name: "Profile",
    path: "/admin/dashboard/profile",
    icon: <FiUser />,
  },
];

const DashboardNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navbarRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const logoutUser = async () => {
    const logoutPromise = api
      .post("/logout")
      .then(() => {
        localStorage.removeItem("access_token");
        sessionStorage.removeItem("access_token");
        dispatch(logout());
        navigate("/");

        toast.success("Logout successful!");
      })
      .catch((error) => {
        localStorage.removeItem("access_token");
        dispatch(logout());
        navigate("/");
        toast.error(
          error.response?.data?.message || "Logout failed. Please try again."
        );
      });

    toast.promise(logoutPromise, {
      loading: "Logging out...",
      success: "Logout successful!",
      error: "Logout failed. Please try again.",
    });
  };
  return (
    <nav className={GlobalStyles.navbarWrapper}>
      <div className={GlobalStyles.navbarContainer}>
        <Link className={GlobalStyles.navbarBrand} to="/">
          <img src={logo} alt="logo" className={GlobalStyles.navbarLogo} />
          <span className={GlobalStyles.navbarLogoText}>{SiteName}</span>
        </Link>
        <div className="flex items-center gap-5">
          <DarkModeToggle />
          <MenuToggleButton
            isOpen={isOpen}
            toggleMenu={toggleMenu}
            dashboard={true}
          />
        </div>
      </div>
      <div
        className={`w-64 h-[calc(100vh-4rem)] absolute left-0 top-full flex flex-col gap-2 justify-between transition-all ease-in-out duration-1000 bg-light dark:bg-dark ${
          isOpen ? "max-lg:translate-x-0" : "max-lg:-translate-x-full"
        } px-3 py-5 ${CommonClasses.transition} lg:border-r border-transparent`}
      >
        <div className={`w-full flex flex-col gap-2`}>
          {menu.map((item) => (
            <Link
              onClick={toggleMenu}
              to={item.path}
              key={item.path} 
              className={`w-full h-9 ${
                CommonClasses.rounded
              } flex items-center  flex-row px-2 gap-2 hover:gap-7 text-xl  capitalize group ${
                CommonClasses.transition
              } ${
                location.pathname === item.path
                  ? "bg-primary text-light dark:text-dark"
                  : "text-primary hover:bg-primary/10 dark:hover:bg-primary/10 border-primary"
              }`}
            >
              <span
                className={`w-6 h-6 text-sm flex items-center justify-center ${
                  CommonClasses.transition
                } ${
                  CommonClasses.rounded
                }  ${
                  location.pathname === item.path
                    ? "text-primary bg-light dark:bg-dark"
                    : "bg-primary text-light dark:text-dark"
                }`}
              >
                {item.icon}
              </span>
              <span className="text-xs group-hover:animate-pulse">
                {item.name}
              </span>
            </Link>
          ))}
          <button onClick={logoutUser} className={GlobalStyles.buttonFull}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default DashboardNavbar;
